



















































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { MiguConfig } from '../utils/constant';
import { javaHost } from '@/bin/javaSetting';
import moduleStore from '../store/migu';
import to from 'await-to-js';
import axios from 'axios';

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class SubscribePopup extends Vue {
  @Prop({ default: false })
  visible: boolean;

  show = false;
  isQuerying = false;

  descList = [
    '"AI视频彩铃-标准版"目前仅支持中国移动用户(不含港澳台)订购，资费19.9元/月，通过话费收取，订购立即生效；退订立即失效，退订的次月起不再收费。',
    '订购该业务，可享专区所有AI工具每月共12次短视频创作，以及微信公众号"清博指数-产品体验-AI视频彩铃"所有视频彩铃任意设置。（注：专区可通过"咪咕音乐App-AI实验室-应用-AI创新应用"、"咪咕彩媒微信小程序-创作-AI创新应用"进入。）',
    '订购该业务时，为具备业务生效所需的功能支持，将为您同步开通0元的视频彩铃功能及主叫视频彩铃功能，如已开通则不会重复开通。同步开通的视频彩铃功能及主叫视频彩铃功能，开通立即生效，退订立即失效（部分省份退订次月生效，具体以您所在省份实际执行标准为准）；如不退订，资费将保持0元/月。',
    '资费有效期3年(36个自然月)，如双方在有效期届满前无异议，有效期自动续展，每次续展3年；有效期内变更/退订/销户/携转，无需承担相应的违约责任。',
    '如需退订，可通过所属省份10086热线、当地中国移动营业厅、中国移动App进行退订。',
    '退订该业务时，不关联退订同步开通的视频彩铃功能及主叫视频彩铃功能，已设置的视频彩铃，在铃音有效期内正常播放。',
    '退订业务后，当月剩余创作次数将自动清零。',
    '办理发起后，平台会通过短信进行验证码、办理结果通知、客服信息等相关的告知，在发起办理时，即视为您同意接收短信。',
    '业务平台客服电话: 400-1897-518(人工服务时间:09:00-18:00)',
  ];

  @Watch('visible', { immediate: true })
  listenVisible(val: boolean) {
    this.show = val;
  }

  closePopup() {
    this.show = false;
    this.isQuerying = false;
    this.$emit('close');
  }

  async doSubscribe() {
    if (this.isQuerying) return;
    this.isQuerying = true;

    try {
      const miguSDK = (window as any).miguSDK;
      if (!miguSDK) {
        console.error('miguSDK 未初始化');
        return;
      }

      // 1. 查询包月包策略
      const monthPolicyCallbackName = miguSDK.generateCallbackName('queryMonthPolicy');
      const monthPolicyResult = await miguSDK.queryMonthPolicy({
        youCallbackName: monthPolicyCallbackName,
        serviceId: '698039049108516515',
      });
      console.log('queryMonthPolicy result:', JSON.stringify(monthPolicyResult));
      // 2. 查询主/被叫视频彩铃功能状态
      const ww_token = localStorage.getItem('session_id') || '';
      const vrbtParams = new URLSearchParams();
      vrbtParams.append('ww_token', ww_token);
      vrbtParams.append('productType', '0');
      vrbtParams.append('ctoken', miguSDK.token || '');
      vrbtParams.append('channelCode', MiguConfig.schannel);
      const [vrbtErr, vrbtRes] = await to(
        axios.get(`${javaHost}/baohuo-yuanchuang/migu/api/v1/queryVrbtFunc?${vrbtParams.toString()}`)
          .then(res => res.data)
      );
      console.log('queryVrbtFunc result:', vrbtErr, JSON.stringify(vrbtRes));
      if (vrbtErr || vrbtRes?.code !== 200) {
        console.error('queryVrbtFunc 失败，流程终止', vrbtErr || vrbtRes?.message);
        return;
      }

      // 3. 根据 vrbtStatus 决定调用哪个订购接口
      const vrbtStatus = vrbtRes?.data?.vrbtStatus;
      console.log(vrbtRes?.data)
      if (vrbtStatus === '1') {
        // 已开通视频彩铃功能，直接走购物车（功能+订阅包）
        const callbackName = miguSDK.generateCallbackName('openVrbtAndSubVrbt');
        this.closePopup();
        const result = await miguSDK.openVrbtAndSubVrbt({
          youCallbackName: callbackName,
          serviceId: '698039049108516515',
        });
        console.log('openVrbtAndSubVrbt result:', JSON.stringify(result));
      } else {
        // 未开通，从 bizInfoMon 取参数走订阅包订购
        const bizInfoMon = monthPolicyResult?.bizInfoMon || {};
        const callbackName = miguSDK.generateCallbackName('orderSubVrbt');
        this.closePopup();
        const result = await miguSDK.orderSubVrbt({
          youCallbackName: callbackName,
          cpId: bizInfoMon.cpId || '',
          bizCode: bizInfoMon.bizCode || '',
          cpparam: bizInfoMon.cpparam || '',
          salePrice: bizInfoMon.salePrice || '',
        });
        console.log('orderSubVrbt result:', JSON.stringify(result));
      }
    } catch (e) {
      console.error('subscribe error:', e);
    } finally {
      this.isQuerying = false;
    }
  }
}
